import { Block, DateSpan } from "../../model/model.interface";

export const fetchEthRewards = async (dates: DateSpan): Promise<Block[]> => {
  const { since, till } = dates;

  // Convert date strings to Unix timestamps
  const fromTimestamp = Math.floor(new Date(since).getTime() / 1000);
  const toTimestamp = Math.floor(new Date(till).getTime() / 1000);

  const url = `https://api.coingecko.com/api/v3/coins/ethereum/market_chart/range?vs_currency=usd&from=${fromTimestamp}&to=${toTimestamp}`;

  try {
    const res = await fetch(url, { method: "GET" });
    if (!res.ok) {
      throw new Error(`Error fetching data: ${res.statusText}`);
    }

    const data = await res.json();
    if (!data?.prices) {
      throw new Error("Unexpected data structure");
    }

    // Group prices by day and calculate daily average
    // CoinGecko returns prices as [[timestamp, price], ...]
    const pricesByDay = new Map<string, number[]>();

    data.prices.forEach(([timestamp, price]: [number, number]) => {
      const dateStr = new Date(timestamp).toISOString().split('T')[0];
      if (!pricesByDay.has(dateStr)) {
        pricesByDay.set(dateStr, []);
      }
      pricesByDay.get(dateStr)!.push(price);
    });

    // Calculate average price for each day
    const blocks: Block[] = Array.from(pricesByDay.entries()).map(([dateStr, prices]) => ({
      reward: prices.reduce((sum, price) => sum + price, 0) / prices.length,
      date: {
        date: dateStr
      }
    }));

    // Sort by date
    blocks.sort((a, b) => a.date.date.localeCompare(b.date.date));

    return blocks;
  } catch (error) {
    console.error("Error fetching blocks:", error);
    throw new Error("Failed to fetch blocks data");
  }
};
